<template>
  <div v-click-outside="lostFocus" class="dropdown text-center" :class="{'displayed':isOpen}">
    <div class="title z-10" :class="{'bg-white':isOpen}">
      <div class="title-text rounded-20 bg-white grid grid-cols-5"
           :class="{'border border-classen__primary':isDetail}">
        <p @click="addToGlobalSelection" class="bg-classen__primary favourite"
           :class="{'text-white':!isInCurrentSelection, 'text-gold': isInCurrentSelection, 'detailMode':isDetail}">
          <i class="fas fa-star"></i>
        </p>
        <p @click="isOpen ? closeSelection() : openSelection()"
           class="col-span-3 overflow-hidden whitespace-nowrap overflow-ellipsis px-1 text-left"
           :class="{'text-gray-400': selectedSelection.id === -1}">
          {{ selectedSelection.name }}
        </p>
        <div @click="isOpen ? closeSelection() : openSelection()">
          <p v-show="!isOpen" class="mr-2"><i class="fas fa-angle-down"></i></p>
          <p v-show="isOpen" class="mr-2"><i class="fas fa-angle-up "></i></p>
        </div>
      </div>
    </div>
    <div class="dropdown-content">
      <div class="h-full px-2">
        <input v-model="searchInput" type="text" :placeholder="getTranslation('search')"
               class="border-shadow searchElement rounded-20 search w-full ml-auto mr-auto mt-2 mb-2 pl-2">
        </input>

        <div class="text-left body flex mb-6 flex-col">
          <div class="h-full">
            <p class="text-xs text-gray-400 h-4">
              {{ getTranslation('suggestions') }}
            </p>
            <div class=" max-h-full text-xs overscroll-contain">
              <div v-for="selection in selectionSuggestions"
                   @click="changeSelection(selection)"
                   class="font-bold flex w-full mb-1 overscroll-contain selectionItem indent-text hover:bg-classen__secondary cursor-pointer">
                <p class="w-9/10 selectionName"
                   :class="{'opacity-30': checkSelection(selection)}">
                  {{ selection.name }}</p>
                <p class="w-1/10 text-right self-end ">
                  <i v-if="selection.type === 'private'" class="fas fa-lock text-right"></i>
                </p>
              </div>
            </div>
          </div>
          <div class="allSelections">
            <p class="text-xs text-gray-400 h-4">
              {{ getTranslation('all') }}
            </p>
            <div class="overflow-y-auto row-span-4 allSelections text-xs overscroll-contain">
              <div @click="changeSelection(defaultSelection)"
                   class="font-bold flex w-full mb-1 overscroll-contain selectionItem indent-text hover:bg-classen__secondary cursor-pointer">
                <p class="w-9/10 selectionName">
                  {{ defaultSelection.name }}
                </p>
              </div>
              <div v-for="selection in filteredSelections"
                   @click="changeSelection(selection)"
                   class="font-bold flex my-1 overscroll-contain selectionItem indent-text hover:bg-classen__secondary cursor-pointer">
                <p class="w-9/10 selectionName"
                   :class="{'text-gray-400': selection.id === -1, 'opacity-30': selection.isProductInSelection}">
                  {{ selection.name }}
                </p>
                <p class="w-1/10 text-center self-end">
                  <i v-if="selection.type === 'private'" class="fas fa-lock text-right"></i>
                </p>
              </div>
            </div>
          </div>
        </div>

        <form @submit.prevent="createSelection()" v-if="hasPermissionToAddSelections()"
              class="text-left text-red-600 z-10 border-t-2 py-1 border-classen__secondary text-sm">
          <div v-if="nameExists" class="text-xs mb-1">
            *{{ getTranslation('selectionExists') }}
          </div>
          <div class="flex">
            <button v-show="!nameExists" type="submit" for="create"
                    class="text-white align-middle add_icon mr-2 bg-classen__primary">
              <i class="fas fa-plus"></i>
            </button>
            <button v-show="nameExists" type="submit" for="create"
                    class="text-white align-middle add_icon mr-2 bg-red-600">
              <i class="fas fa-times"></i>
            </button>
            <input id="create" type="text" v-model="createInput" class="text-black"
                   :placeholder="getTranslation('createNewSelection')" required autocomplete="off"/>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>

import ClickOutside from 'vue-click-outside'
import EventBus from "../../services/EventBus";
import Decors from "./Decors/Decors";
import Input from "../form/Input";
import getTranslation from "../../mixins/getTranslation";
import Button from "../Button";
import getPermissions from "../../mixins/getPermissions";

export default {
  name: "SelectionDropdown",

  components: {Button, Input, Decors},

  props: {
    product: {required: false, type: Object},
    decor: {required: false, type: Object},
    mode: {required: false, type: String, default: 'product'},
    selectedSelection: {
      required: false,
      type: Object,
      default: function () {
        return {id: -1, name: 'Set default selection'}
      }
    },
    isDetail: {required: false, type: Boolean, default: false}
  },

  created() {
    if (!this.selectedSelection) {
      this.selectedSelection = {id: -1, name: 'Set default selection'}
    }

    if (this.mode === 'product') {
      this.$dashboardStore.dispatch('getProductQuickSelection', this.product.articleNumber)
    }

    if (this.mode === 'decor') {
      this.$dashboardStore.dispatch('getDecorQuickSelection', this.decor.id)
    }

    EventBus.listen('close-selection', this.closeSelection);
  },

  destroyed() {
    EventBus.destroy('close-selection', this.closeSelection);
  },

  mixins: [getTranslation, getPermissions],

  data() {
    return {
      isOpen: false,
      searchInput: '',
      createInput: '',
      added: false,
      defaultSelection: {id: -1, name: "Set default selection"},
      hasError: true,
    }
  },

  computed: {
    isInCurrentSelection() {
      if (!this.selectedSelection) {
        return false;
      }

      let sel;
      if (this.mode === 'product') {
        sel = this.product.selections.find((selection) => selection.id === this.selectedSelection.id);
      }

      if (this.mode === 'decor') {
        sel = this.decor.selections.find((selection) => selection.id === this.selectedSelection.id);
      }

      return sel !== undefined
    },

    nameExists() {
      return this.selections.find((selection) => {
        return selection.name === this.createInput
      }) !== undefined;
    },

    selections() {
      let selections = this.$dashboardStore.getters.getSelections;
      if (this.activeUserHasRole(this.ROLES.SALES_ADMIN)) {
        selections = selections.filter((selection) => selection.type !== 'public');
      }
      return selections;
    },

    selectionSuggestions() {
      let selectionSuggestions = this.$dashboardStore.getters.getSelectionSuggestions;
      if (this.activeUserHasRole(this.ROLES.SALES_ADMIN)) {
        selectionSuggestions = selectionSuggestions.filter((suggestion) => suggestion.type !== 'public');
      }
      return selectionSuggestions;
    },

    filteredSelections() {
      if (this.quickSelection.length === 0 || this.quickSelection[0] === 'Loading') {
        return []
      }

      if (this.searchInput === '') {
        return this.quickSelection;
      }

      return this.quickSelection.filter((selection) => {
        return selection.name.toLowerCase().includes(this.searchInput.toLowerCase());
      })
    },

    quickSelection() {
      let qs;
      if (this.mode === 'product') {
        qs = this.$dashboardStore.getters.getProductQuickSelections.find((quick) => {
          return quick.productId === this.product.articleNumber
        });
      }

      if (this.mode === 'decor') {
        qs = this.$dashboardStore.getters.getDecorQuickSelections.find((quick) => {
          return quick.decorId === this.decor.id
        });
      }

      if (!qs || qs.length === 0) {
        return [];
      }

      return qs.quickSelection;
    }
  },

  methods: {
    checkSelection(selection) {
      let qSelection = this.quickSelection.find((qs) => qs.id === selection.id)
      if (qSelection) {
        return qSelection.isProductInSelection;
      }

      return false;
    },

    lostFocus() {
      this.isOpen = false;
    },

    addToGlobalSelection() {
      if (!this.isInCurrentSelection) {
        this.$emit('addSelectionToProduct', this.selectedSelection)
        if (this.mode === 'product') {
          this.$dashboardStore.dispatch('forceUpdateQuickSelectionProduct', this.product.articleNumber)
          return
        }

        if (this.mode === 'decor') {
          this.$dashboardStore.dispatch('forceUpdateQuickSelectionDecor', this.decor.id)
          return
        }
      }

      if (this.isDetail) {
        this.$emit('removeSelectionFromProduct', this.selectedSelection)
        return;
      }

      this.$emit('removeSelectionFromProduct', this.selectedSelection)
    },

    changeSelection(selection) {
      this.closeSelection();
      this.$emit('changed-selection', selection)
      this.$nextTick(() => {
        this.selectedSelection = selection;
      })
    },

    createSelection() {
      if (this.createInput.length === 0 || this.nameExists) {
        this.hasError = true;
        return
      }

      let selection = {name: this.createInput, memo: "", type: 'private'};

      this.$dashboardStore.dispatch('addSelection', selection)
        .then((res) => {
          this.$dashboardStore.commit('ADD_SELECTION', res.data);
          window.location.reload();
          this.createInput = "";
        })
    },

    closeSelection() {
      this.isOpen = false
    },

    openSelection() {
      EventBus.fire('close-menus');
      EventBus.fire('close-selection');
      EventBus.fire('close-nav');
      this.isOpen = true;
    },
  },

  directives: {
    ClickOutside
  }

}
</script>

<style scoped>
.title-text {
  height: 40px;
  line-height: 40px;
}

.title {
  height: 42px;
  border-radius: 20px 20px 0 0;
}

.displayed > .title {
  /*border: 1px solid #EAEBEC;*/
  border-bottom: none;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #FFFFFF;
  width: 100%;
  height: fit-content;
  /*height: fit-content;*/
  /*padding: 12px 16px;*/
  z-index: 1;
  border-radius: 0 0 20px 0;
  border: 1px solid #EAEBEC;
  border-top: none;
}

.displayed .dropdown-content {
  display: block;
}

.favourite {
  border-radius: 40px 0 0 40px;
}

.search {
  height: 35px;
}

.add_icon {
  height: 20px;
  width: 20px;
  border-radius: 10px;
  text-align: center;
}

.body {
  grid-template-rows: 120px 190px;
}

.selectionItem::first-letter {
  text-transform: capitalize;
}

.selectionItem {
  min-height: 20px;
}

.allSelections {
  max-height: 190px
}

.searchElement::placeholder {
  color: #c7c7c7;
}

.selectionName {
  word-spacing: 3px;
}

.detailMode {
  margin-top: -1px;
  margin-bottom: 1px;
}
</style>
